<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<p-contextMenu #viewContextMenu [model]="viewsContextMenuItems"></p-contextMenu>
<app-clearing-sidebar [selectedOrderIds]="selectedOrderIds" [tradeModeEnabled]="orderClearingsActive"
                    [(ordersTradesFilter)]="ordersTradesFilter" (ordersTradesFilterChange)="refreshCurrentView()">

<mat-tab-group body class="tradesOrdersContainer" [(selectedIndex)]="selectedViewIndex"
               (selectedIndexChange)="viewChanged($event)"
               animationDuration="800ms">
  <mat-tab *ngFor="let userView of userViews">
    <ng-template mat-tab-label>
      <span class="mat-tab-label-content" (contextmenu)="showTabContextMenu($event, userView)">
      <mat-icon [class]="userView.viewIco"></mat-icon>
        {{userView.viewName}}</span>
    </ng-template>
    <ng-template matTabContent>
      <app-tradesorders #tradeOrders [userView]="userView" [ordersTradesFilter]="ordersTradesFilter"
                        [(selectedOrderIds)]="selectedOrderIds" [(orderClearingsActive)]="orderClearingsActive"
                        [(selectedTradeIds)]="selectedTradeIds"></app-tradesorders>
    </ng-template>
  </mat-tab>
  <mat-tab *ngIf="viewEditable" disabled>
    <ng-template mat-tab-label>
      <button pButton pRipple type="button" icon="fas fa-plus" class="view-tab-btt view-tab-add p-button-text p-button-sm"
              (click)="createView()"></button>
    </ng-template>
  </mat-tab>
  <mat-tab *ngIf="viewEditable" disabled>
    <ng-template mat-tab-label>
      <button pButton pRipple type="button" icon="fas fa-sliders" class="view-tab-btt view-tab-edit p-button-text p-button-sm"
              (click)="editViews()"></button>
    </ng-template>
  </mat-tab>
</mat-tab-group>
</app-clearing-sidebar>

<app-user-view-form [formRecord]="userViewFormRecord"
                    [(dialogFormVisible)]="userViewFormVisible"
                    (onSave)="refreshViews()"></app-user-view-form>

<app-user-views-dialog #userViewDialog [(dialogFormVisible)]="userViewsListVisible" (dialogFormVisibleChange)="viewsChanged($event)"></app-user-views-dialog>


